module.exports = __webpack_public_path__ + "bn.2c4223922139dcc8dc6c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bn.svg
// module chunks = styles